export default function codeGeneral() {
  return {
    _id: false,
    type: 'droplet.codeGeneral',
    code: 'Open droplet settings to start coding...',
    hidden: false,
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/code-general/droplet.schema.js